// extracted by mini-css-extract-plugin
module.exports = {"list":"the-quolifications_list_3C2xX","item":"the-quolifications_item_19k13","content":"the-quolifications_content_Xd5zz"};